module.exports = __webpack_public_path__ + "static/img/sh_bg_apply.196c175.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sh_bg_apply.png
// module id = V68L
// module chunks = 1